import { getToken } from "firebase/messaging";
import { messaging } from "./firebase/firebase";
import { onMessage } from "firebase/messaging";

export const requestPermissionAndGetToken = async () => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Permission denied");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPIDKEY || "Your vapidkey", // from Firebase console
    });

    // console.log("FCM Token:", token);
    // 🔥 Send this token to backend
    return token;
  } catch (error) {
    console.error("Error getting token:", error);
  }
};

export const listenToMessages = () => {
  onMessage(messaging, (payload) => {
    console.log("Foreground message:", payload);

    if (Notification.permission === "granted") {
      new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: "/logo-icon.png",
      });
    }
  });
};
